<template>
  <div class="di-tu">
    <div class="di-tu__shen-zhen">
      <img src="@/assets/shenzhen.png" alt="shenzhen">
    </div>
    <div class="di-tu__background">
      <div class="di-tu__di-qiu">
        <img src="@/assets/earth.png" alt="di-qiu">
      </div>
      <div class="di-tu__wang-luo">
        <img src="@/assets/wang-luo.png" alt="wang-luo">
      </div>
      <div class="di-tu__guang-quan">
        <img src="@/assets/guang-quan.png" alt="guang-quan">
      </div>
    </div>
    <div class="list">
      <div class="item item-dapeng">
        <div class="district">大鹏新区</div>
        <div class="count">{{ dataMap?.get('大鹏新区')?.count || 0 }}</div>
      </div>
      <div class="item item-baoan">
        <div class="district">宝安区</div>
        <div class="count">{{ dataMap?.get('宝安区')?.count || 0 }}</div>
      </div>
      <div class="item item-longhua">
        <div class="district">龙华新区</div>
        <div class="count">{{ dataMap?.get('龙华新区')?.count || 0 }}</div>
      </div>
      <div class="item item-luohu">
        <div class="district">罗湖区</div>
        <div class="count">{{ dataMap?.get('罗湖区')?.count || 0 }}</div>
      </div>
      <div class="item item-longgang">
        <div class="district">龙岗区</div>
        <div class="count">{{ dataMap?.get('龙岗区')?.count || 0 }}</div>
      </div>
      <div class="item item-futian">
        <div class="district">福田区</div>
        <div class="count">{{ dataMap?.get('福田区')?.count || 0 }}</div>
      </div>
      <div class="item item-nanshan">
        <div class="district">南山区</div>
        <div class="count">{{ dataMap?.get('南山区')?.count || 0 }}</div>
      </div>
      <div class="item item-yantian">
        <div class="district">盐田区</div>
        <div class="count">{{ dataMap?.get('盐田区')?.count || 0 }}</div>
      </div>
      <div class="item item-pingshan">
        <div class="district">坪山新区</div>
        <div class="count">{{ dataMap?.get('坪山新区')?.count || 0 }}</div>
      </div>
      <div class="item item-guangming">
        <div class="district">光明新区</div>
        <div class="count">{{ dataMap?.get('光明新区')?.count || 0 }}</div>
      </div>
      <div class="item item-shenshan">
        <div class="district">深汕特别合作区</div>
        <div class="count">{{ dataMap?.get('深汕特别合作区')?.count || 0 }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/util/request.js'

export default {
  components: {},
  data () {
    return {
      timer: null,
      dataMap: null
    }
  },
  async mounted () {
    this.loadMap()

    this.timer = setInterval(() => {
      this.loadMap()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  methods: {
    async loadMap () {
      const res = await request.get('/common/yin-huan-shu-liang-qu-yu-fen-bu')
      const map = new Map()
      for (const item of res.data) {
        const key = item.district
        map.set(key, item)
      }
      this.dataMap = map
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.di-tu {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .di-tu__shen-zhen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      width: 90%;
    }
  }

  .di-tu__background {
    width: 100%;
    height: 100%;
    position: relative;

    .di-tu__wang-luo {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 100%;
        animation: xuan-zhuan 30s linear infinite;
      }
    }

    .di-tu__di-qiu {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 90%;
        animation: xuan-zhuan 10s linear infinite;
      }
    }

    .di-tu__guang-quan {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 100%;
        animation: xuan-zhuan 10s linear infinite reverse;
      }
    }
  }
}

@keyframes xuan-zhuan {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.list {
  font-size: 14px;
  color: #fff;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  position: absolute;
  transition: .3s all ease-in-out;

  &:hover {
    font-size: 16px;
    font-weight: bold;
  }
}

.item-baoan {
  left: 12%;
  top: 45%;
}

.item-guangming {
  left: 18%;
  top: 28%;
}

.item-nanshan {
  left: 22%;
  top: 55%;
}

.item-longhua {
  left: 27%;
  top: 38%;
}

.item-futian {
  left: 30%;
  top: 60%;
}

.item-longgang {
  left: 46%;
  top: 40%;
}

.item-luohu {
  left: 39%;
  top: 55%;
}

.item-yantian {
  left: 50%;
  top: 53%;
}

.item-pingshan {
  left: 57%;
  top: 40%;
}

.item-dapeng {
  left: 70%;
  top: 55%;
}

.item-shenshan {
  left: 80%;
  top: 30%;
}

</style>
